import { useEffect, useState, useRef } from "react";
//import { Flag } from "../../components/Flag/Flag";
import { Map, APIProvider, useMap, AdvancedMarker } from '@vis.gl/react-google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Marker, GridAlgorithm } from '@googlemaps/markerclusterer';
import { CircularProgress } from '@mui/material';
//import { transform } from "lodash";
//import Trips from '../Trips/Trips';
//import Recommendations from "../Recommendations/Recommendations";
import "./MapComponent.scss";
import "../Trips/Trips.scss";
import "../Recommendations/Recommendations.scss";
import "../Layout/Layout.scss";



interface PlaceLocation {
    lat: string;
    lng: string;
}
  
interface Recommendation {
    _id: string;
    place: {
      location: PlaceLocation;
      name: string;
      images: {
        urls: {
          thumb: string;
          raw: string;
        };
      };
      types: string[];
    };
    user: {
      firstName: string;
      lastName: string;
      avatar: string;
    };
    review: number;
    placeTypesTags: string[];
    locality: string;
    state_code: string;
}
  
/*interface RecommendationsProps {
    openModal: (arg: any) => void;
}*/
  
  
  // TRIPS
interface TripPlaceLocation {
    description: string;
    location: {
      lat: string;
      lng: string;
    };
}
  
interface TripTraveler {
    _id: string;
    email: string;
    firstName: string;
    lastName: string;
    picture: string;
}
  
interface Trip {
    _id: string;
    title: string;
    whereTo: TripPlaceLocation[];
    statusType: string;
    travelers: TripTraveler[];
    images: {
      urls: {
        thumb: string;
        small: string;
        raw: string;
      };
    };
    daysRange: string;
    formattedDate: string;
}
  
/*interface TripData {
    data: Trip[];
    formattedDate: string;
}
  
interface TripsProps {
    openModal: (arg: any) => void;
}*/


export default function NewMapComponent({ recs, trips, mapView, selectedRec, selectedTrip, loadingRecs, isFilteringRecs, loadingTrips, isFilteringTrips, locationTags, setSelectedRec, setSelectedTrip }: { recs: Recommendation[]; trips: Trip[]; selectedRec: Recommendation | null; selectedTrip: Trip | null; mapView: 'recs' | 'trips'; loadingRecs: boolean; isFilteringRecs: boolean; loadingTrips: boolean; isFilteringTrips: boolean; locationTags: any[]; setSelectedRec: (rec: Recommendation | null) => void; setSelectedTrip: (rec: Trip | null) => void }) {
    
    const apiKey = process.env.REACT_APP_PANGEA_GOOGLE_MAPS_API_KEY || '';
      
    const mobileCenter = {
        lat: 47.7691,
        lng: -95.9861
    };


    return (
        <div style={{ height: '100%', width: '100%', scrollbarWidth: 'none' }}>
            <APIProvider apiKey={apiKey}>
                <Map
                    defaultCenter={mobileCenter}
                    defaultZoom={3}
                    maxZoom={16}
                    mapId={process.env.REACT_APP_PANGEA_GOOGLE_MAPS_MAP_ID}
                    disableDefaultUI={true}
                    onClick={() => {
                        if (mapView === 'recs') {
                            setSelectedRec(null);
                        } else if (mapView === 'trips') {
                            setSelectedTrip(null);
                        }
                    }}
                >
                    <Markers mapView={mapView} recs={recs} trips={trips} loadingRecs={loadingRecs} isFilteringRecs={isFilteringRecs} loadingTrips={loadingTrips} isFilteringTrips={isFilteringTrips} locationTags={locationTags} selectedRec={selectedRec} setSelectedRec={setSelectedRec} selectedTrip={selectedTrip} setSelectedTrip={setSelectedTrip} />
                    {((mapView === 'recs') && loadingRecs) ? <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -25%)', height: 75, width: 75, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress thickness={5}/></div> : null}
                    {((mapView === 'trips') && loadingTrips) ? <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -25%)', height: 75, width: 75, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress thickness={5}/></div> : null}
                </Map>
            </APIProvider>
        </div>
    )
}

interface MarkersProps {
    mapView: 'recs' | 'trips';
    recs: Recommendation[];
    trips: Trip[];
    locationTags: any[];
    loadingRecs: boolean;
    isFilteringRecs: boolean;
    loadingTrips: boolean;
    isFilteringTrips: boolean;
    selectedRec: Recommendation | null;
    selectedTrip: Trip | null;
    setSelectedRec: (rec: Recommendation | null) => void;
    setSelectedTrip: (trip: Trip | null) => void;
}

const Markers = ({ mapView, recs, trips, loadingRecs, isFilteringRecs, loadingTrips, isFilteringTrips, locationTags, selectedRec, selectedTrip, setSelectedRec, setSelectedTrip }: MarkersProps) => {
    const map = useMap();
    const [recMarkers, setRecMarkers] = useState<{ [_id: string]: Marker}>({});
    const [tripMarkers, setTripMarkers] = useState<{ [_id: string]: Marker }>({});
    const clusterer = useRef<MarkerClusterer | null>(null);

    // Use a ref to keep track of the previous zoom level for smoother transitions
    const prevZoomRef = useRef<number | null | undefined>(null);


    // Center the map when `selectedRec` or `selectedTrip` changes
    useEffect(() => {
        if (!map) return;

        let lat: number | null = null;
        let lng: number | null = null;

        if (selectedRec) {
            lat = parseFloat(selectedRec.place.location.lat);
            lng = parseFloat(selectedRec.place.location.lng);
        } else if (selectedTrip) {
            lat = parseFloat(selectedTrip.whereTo[0].location.lat);
            lng = parseFloat(selectedTrip.whereTo[0].location.lng);
        }

        if (lat !== null && lng !== null) {
            const zoom = prevZoomRef.current ?? 14; // Get current zoom level or default to 12
            const offset = 0.05 / Math.pow(2, zoom - 12); // Adjust offset dynamically based on zoom
        
            const adjustedLat = lat + offset; // Move the map slightly upward
            map.panTo({ lat: adjustedLat, lng });
        
            // Optional: Set a new zoom level
            const newZoom = prevZoomRef.current ?? zoom;
            map.setZoom(newZoom);
        
            // Update the previous zoom reference
            prevZoomRef.current = map.getZoom();
          }
    }, [map, selectedRec, selectedTrip]);


    useEffect(() => {
        if (!map) return;
        const clusterRenderer = {
            render: ({ count, position }: { count: number; position: google.maps.LatLng }) => {
                const size = count < 10 ? 40 : count < 50 ? 50 : 60; // Adjust cluster size based on count
    
                const div = document.createElement("div");
                div.style.width = `${size}px`;
                div.style.height = `${size}px`;
                div.style.backgroundColor = "#01d2ff"; // Set cluster background color
                div.style.borderRadius = "50%";
                div.style.border = "1px solid white";
                div.style.display = "flex";
                div.style.justifyContent = "center";
                div.style.alignItems = "center";
                div.style.color = "white";
                div.style.fontSize = "14px";
                div.style.fontWeight = "bold";
                div.textContent = `${count}`; // Display the number of markers in the cluster
    
                return new google.maps.marker.AdvancedMarkerElement({
                    position,
                    content: div,
                });
            },
        };

    
        // Initialize the MarkerClusterer with the custom renderer
        if (!clusterer.current) {
            clusterer.current = new MarkerClusterer({
                map,
                markers: [], // Initialize with no markers
                renderer: clusterRenderer,
                algorithm: new GridAlgorithm({})
            });
        }

        // Add custom zoom behavior on cluster click
        /*clusterer.current.onClusterClick = (event) => {
            const cluster = event.cluster;
            const newZoomLevel = Math.min(map.getZoom() + 1, 12); // Adjust zoom level, limit to a max zoom level (e.g., 12)
            map.panTo(cluster.position); // Center map to cluster position
            map.setZoom(newZoomLevel);
        };*/
    }, [map]);


    useEffect(() => {
        if (mapView === 'recs') {
            clusterer.current?.clearMarkers();
            clusterer.current?.addMarkers(Object.values(recMarkers))
        }
        if (mapView === 'trips') {
            clusterer.current?.clearMarkers();
            clusterer.current?.addMarkers(Object.values(tripMarkers))
        }
    }, [mapView, recMarkers, tripMarkers]);


    const setRecMarkerRef = (marker: Marker | null, _id: string) => {
        if (marker && recMarkers[_id]) return;
        if (!marker && !recMarkers[_id]) return;

        setRecMarkers(prev => {
            if (marker) {
                return {...prev, [_id]: marker}
            } else {
                const newRecMarkers = {...prev};
                delete newRecMarkers[_id];
                return newRecMarkers;
            }
        })
    };


    const setTripMarkerRef = (marker: Marker | null, _id: string) => {
        if (marker && tripMarkers[_id]) return;
        if (!marker && !tripMarkers[_id]) return;

        setTripMarkers(prev => {
            if (marker) {
                return {...prev, [_id]: marker}
            } else {
                const newTripMarkers = {...prev};
                delete newTripMarkers[_id];
                return newTripMarkers;
            }
        })
    };


    useEffect(() => {
        if ((locationTags.length > 0) && (locationTags.length < 2)) {
          if (map && recs.length) {
            map.panTo({ lat: parseFloat(recs[0].place.location.lat), lng: parseFloat(recs[0].place.location.lng) });  // Center the map on the first filtered rec marker
            map.setZoom(11);      // Zoom in (you can adjust the zoom level)
          }
        }
    }, [map, locationTags, recs]);




    // REC MAP MARKERS !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // Render out rec names for the Recs map markers
    const renderRecNames = (rec: Recommendation) => {
        let thisRec = JSON.parse(JSON.stringify(rec));
        let recName = thisRec.place && thisRec.place.name && thisRec.place.name;
        return (
            <div className="rec-map-marker-tag-title" style={{ color: ((selectedRec !== null) && (selectedRec._id.toString() === rec._id.toString())) ? 'var(--white-100, #FFF)' : 'var(--Metal-metal-900, #050505)' }}>
                {recName}
            </div>
        )
    };

    // Render out rec description for the Recs map markers
    const renderRecDescription = (rec: Recommendation) => {
        let thisRec = JSON.parse(JSON.stringify(rec));
        const renderReviewStatus = (review: number) => {
            switch(review) {
              case 0: 
                return 'Not a fan 👎';
              case 1: 
                return 'Liked 👍';
              case 2: 
                return 'Loved 😍';
              default:
                return 'liked 👍';
            }
        };
        return (
            <div className="rec-map-marker-tag-description" style={{ background: ((selectedRec !== null) && (selectedRec._id.toString() === rec._id.toString())) ? 'var(--Metal-metal-600, #626E8E)' : 'var(--white-100, #FFF)' }}>
                <div className="rec-map-marker-tag-description-avatars">
                    <img
                        className="rec-map-marker-tag-description-avatar"
                        src={thisRec.user && thisRec.user.picture && thisRec.user.picture}
                        alt={`${thisRec.user.firstName}`}
                        loading="lazy"
                    />
                </div>
                <div className="rec-map-marker-tag-description-text">
                    <div className="rec-map-marker-tag-description-font" style={{ color: ((selectedRec !== null) && (selectedRec._id.toString() === rec._id.toString())) ? 'var(--white-100, #FFF)' : 'var(--Metal-metal-900, #050505)' }}>
                        {`${thisRec.user && thisRec.user.firstName} ${(thisRec.visited === true) ? thisRec.review ? (renderReviewStatus(thisRec.review)) : 'liked 👍' : "Want's to go 💫"}`}
                    </div>
                </div>
            </div>
        )
    };


    const renderRecPlaceTypeIcon = (rec: Recommendation) => {
        let thisRec = JSON.parse(JSON.stringify(rec));
        const recTagObjects = [
            {
                "_id": "65337c6f65d98ab149172893",
                "title": "Experience",
                "icon": "🥳",
                "rank": 8
            },
            {
                "_id": "65337c7165d98ab14917289c",
                "title": "Shop",
                "icon": "👜",
                "rank": 7
            },
            {
                "_id": "65337c7765d98ab1491728b6",
                "title": "Self Care",
                "icon": "💆",
                "rank": 11
            },
            {
                "_id": "65337c7965d98ab1491728bc",
                "title": "Restaurants",
                "icon": "🍽",
                "rank": 1
            },
            {
                "_id": "65337c7b65d98ab1491728c1",
                "title": "See",
                "icon": "👀",
                "rank": 4
            },
            {
                "_id": "65337c7e65d98ab1491728cf",
                "title": "Nature",
                "icon": "🏔",
                "rank": 10
            },
            {
                "_id": "65337c8165d98ab1491728d8",
                "title": "Services",
                "icon": "📋",
                "rank": 13
            },
            {
                "_id": "65337c8465d98ab1491728e0",
                "title": "Health",
                "icon": "🧘‍♀️",
                "rank": 9
            },
            {
                "_id": "65337c8865d98ab1491728ef",
                "title": "Café",
                "icon": "☕️",
                "rank": 3
            },
            {
                "_id": "65337c8a65d98ab1491728f1",
                "title": "Bar",
                "icon": "🥂",
                "rank": 2
            },
            {
                "_id": "65337c9065d98ab149172901",
                "title": "Stay",
                "icon": "🛌",
                "rank": 12
            },
            {
                "_id": "66217c09c4680774194f87ce",
                "title": "Coworking",
                "icon": "👩‍💻",
                "rank": 6,
            },
            {
                "_id": "66217c09c4680774194f87cf",
                "title": "Coliving",
                "icon": "🤗",
                "rank": 5,
            }
        ];

        let thisRecPlaceTypes = thisRec.placeTypesTags && thisRec.placeTypesTags;
        let getThisRecsObjects = thisRecPlaceTypes && thisRecPlaceTypes.length
            ? recTagObjects && recTagObjects.length && recTagObjects.filter((recTagObj: any) => thisRecPlaceTypes.some((recPlaceType: any) => recPlaceType === recTagObj._id)).sort((a, b) => a.rank - b.rank)
            : [{
                "title": "Want's To Go",
                "icon": "💫",
                "rank": 1,
            }];
        let thisPrimaryRecType = getThisRecsObjects && getThisRecsObjects.length && getThisRecsObjects;
        return (
            <div className="rec-map-marker-icon-place-type-icon">
                {thisPrimaryRecType && thisPrimaryRecType.length && thisPrimaryRecType[0].icon}
            </div>
        );
    };


    const renderRecImage = (images: any) => {
        let allImages = JSON.parse(JSON.stringify(images));
        let imageUrls = allImages && allImages.urls && allImages.urls;
        let recLocationImage = imageUrls.raw || images.regular || "http://www.gravatar.com/avatar/?d=mp";
        return (
            <img 
                alt="Rec Location Marker Icon"
                src={recLocationImage}
                className="rec-map-marker-icon-image-ellipse1"
                loading="lazy"
            />
        )
    };



    // TRIP MAP MARKERS !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // Render out traveler names for the Trips map markers
    const renderTripLocation = (usersD: any) => {
        let trip = JSON.parse(JSON.stringify(usersD));
        let whereTo = trip && trip.whereTo && trip.whereTo;
        let usersData = whereTo && whereTo;
        let primaryTrip = usersData && usersData.length && usersData[0];
        let primaryLocation = primaryTrip.description;
        //{`${primaryTraveler && primaryTraveler.firstName} ${primaryTraveler && primaryTraveler.lastName && primaryTraveler.lastName.charAt(0)}. ${(totalTravelers > 1) ? `+${(totalTravelers - 1)}` : ''}`}
        return (
            <div className="trip-map-marker-tag-text-travelers" style={{ color: ((selectedTrip !== null) && (selectedTrip._id.toString() === trip._id.toString())) ? 'var(--white-100, #FFF)' : 'var(--Metal-metal-900, #050505)' }}>
                {primaryLocation}
            </div>
        )
    };

    // Render out traveler names for the Trips map markers
    const renderTravelDates = (usersD: any) => {
        let usersData = JSON.parse(JSON.stringify(usersD));
        let dates = usersData.when && usersData.when;
        let startDateStr = dates.startDate && dates.startDate;
        let endDateStr = dates.endDate && dates.endDate;
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);

        const formatDateToMMMYY = (dateStr: any) => {
            const inputDate: any = new Date(dateStr);
            const today: any = new Date();
          
            // Calculate the difference in days
            const diffInDays = Math.ceil((inputDate - today) / (1000 * 60 * 60 * 24));
          
            if (diffInDays > 180) {
              // Format as "MMM 'YY" if more than 180 days away
              const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              const month = months[inputDate.getUTCMonth()];
              const year = `'${inputDate.getUTCFullYear() % 100}`;
              return `${month} ${year}`;
            } else {
              // Format as "MMM DD" otherwise
              return false;
            }
        };
          
        const datesFurtherThan6MonthsAway = formatDateToMMMYY(startDateStr);
        

        const formattedStartDate = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
        }).format(startDate);

        const formattedEndDate = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
        }).format(endDate);

        //const formattedYear = `'${endDate.getUTCFullYear().toString().slice(-2)}`;

        return (
            <div className="trip-map-marker-tag-text-dates" style={{ color: ((selectedTrip !== null) && (selectedTrip._id.toString() === usersData._id.toString())) ? 'var(--Metal-metal-200, #CCD0DC)' : 'var(--Metal-metal-900, #050505)' }}>
                {(datesFurtherThan6MonthsAway !== false) ? datesFurtherThan6MonthsAway : `${formattedStartDate} - ${formattedEndDate}`}
            </div>
        )
    };

    // Render out traveler image for the Trips map markers
    const renderTravelImage = (images: any) => {
        let allImages = JSON.parse(JSON.stringify(images));
        let imageUrls = allImages && allImages.urls && allImages.urls;
        let tripLocationImage = imageUrls.raw || images.regular || "http://www.gravatar.com/avatar/?d=mp";
        return (
            <img 
                alt="Trip Location Marker Icon"
                src={tripLocationImage}
                className="trip-map-marker-icon-image-ellipse1"
                loading="lazy"
            />
        )
    };

    
    return (
        <>
            {((mapView === 'recs') && !loadingRecs && !isFilteringRecs) ? (
                recs.map((rec: Recommendation) => {
                    const position = {
                        lat: parseFloat(rec.place.location.lat),
                        lng: parseFloat(rec.place.location.lng),
                    };
        
                    return (
                        <AdvancedMarker
                            key={rec._id}
                            ref={(marker) => setRecMarkerRef(marker, rec._id)}
                            position={position}
                            onClick={() => {
                                setSelectedRec(rec);
                            }}
                        >
                            <div className="rec-map-marker-container">
                                <div className="rec-map-marker-tag" style={{ background: ((selectedRec !== null) && (selectedRec._id.toString() === rec._id.toString())) ? 'var(--Metal-metal-700, #49526A)' : 'var(--white-100, #FFF)' }}>
                                    {renderRecNames(rec)}
                                    {renderRecDescription(rec)}
                                </div>
                                <div className="rec-map-marker-icon">
                                    <div className="rec-map-marker-icon-image">
                                        <div className="rec-map-marker-icon-image-vector">
                                        {((selectedRec !== null) && (selectedRec._id.toString() === rec._id.toString())) ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="95" viewBox="0 0 85 95" fill="none">
                                                <g filter="url(#filter0_d_3031_1559)">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M53.833 69.2545C66.8411 64.6214 76.1072 52.1835 76.1072 37.6073C76.1072 19.0395 61.0676 4 42.4999 4C23.9321 4 8.89258 19.0395 8.89258 37.6073C8.89258 53.1101 19.406 66.1539 33.6615 70.0385L42.4286 82.4387C42.9275 83.1871 44.068 83.1871 44.5669 82.4387L53.833 69.2545Z" fill="#49526A"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_d_3031_1559" x="0.892578" y="0" width="83.2148" height="95" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                    <feOffset dy="4"/>
                                                    <feGaussianBlur stdDeviation="4"/>
                                                    <feComposite in2="hardAlpha" operator="out"/>
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3031_1559"/>
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3031_1559" result="shape"/>
                                                    </filter>
                                                </defs>
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="95" viewBox="0 0 85 95" fill="none">
                                                <g filter="url(#filter0_d_2658_4717)">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M53.833 69.2545C66.8411 64.6214 76.1072 52.1835 76.1072 37.6073C76.1072 19.0395 61.0676 4 42.4999 4C23.9321 4 8.89258 19.0395 8.89258 37.6073C8.89258 53.1101 19.406 66.1539 33.6615 70.0385L42.4286 82.4387C42.9275 83.1871 44.068 83.1871 44.5669 82.4387L53.833 69.2545Z" fill="white"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_d_2658_4717" x="0.892578" y="0" width="83.2148" height="95" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                    <feOffset dy="4"/>
                                                    <feGaussianBlur stdDeviation="4"/>
                                                    <feComposite in2="hardAlpha" operator="out"/>
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2658_4717"/>
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2658_4717" result="shape"/>
                                                    </filter>
                                                </defs>
                                            </svg>
                                        )}
                                        </div>
                                        {renderRecImage(rec.place.images)}
                                        <div className="rec-map-marker-icon-place-type">
                                            {renderRecPlaceTypeIcon(rec)}
                                        </div>
                                    </div>
                                    <div className="rec-map-marker-icon-shadow">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="14" viewBox="0 0 55 14" fill="none">
                                            <path opacity="0.5" d="M27.5 0C42.4117 0 54.5 3.13398 54.5 6.99998C54.5 10.866 42.4117 14 27.5 14C12.5883 14 0.5 10.866 0.5 6.99998C0.5 3.13398 12.5883 0 27.5 0Z" fill="url(#paint0_radial_2658_4720)"/>
                                            <defs>
                                                <radialGradient id="paint0_radial_2658_4720" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27.5073 7.00883) rotate(1.1263) scale(26.3569 6.22176)">
                                                <stop/>
                                                <stop offset="1" stopOpacity="0"/>
                                                </radialGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </AdvancedMarker>
                    );
                })
            ): null}
            {((mapView === 'trips') && !loadingTrips && !isFilteringTrips) ? (
                trips.map((trip: Trip) => {
                    const position = {
                        lat: parseFloat(trip.whereTo[0].location.lat),
                        lng: parseFloat(trip.whereTo[0].location.lng),
                    };
        
                    return (
                        <AdvancedMarker
                            key={trip._id}
                            ref={(marker) => setTripMarkerRef(marker, trip._id)}
                            position={position}
                            onClick={() => {
                                setSelectedTrip(trip);
                            }}
                        >
                            <div className="trip-map-marker-container">
                                <div className="trip-map-marker-tag" style={{ background: ((selectedTrip !== null) && (selectedTrip._id.toString() === trip._id.toString())) ? 'var(--Metal-metal-600, #626E8E)' : 'var(--white-100, #FFF)' }}>
                                    <div className="trip-map-marker-tag-text">
                                        {renderTripLocation(trip)}
                                        {renderTravelDates(trip)}
                                    </div>
                                </div>
                                <div className="trip-map-marker-icon">
                                    <div className="trip-map-marker-icon-image">
                                        <div className="trip-map-marker-icon-image-vector">
                                            {((selectedTrip !== null) && (selectedTrip._id.toString() === trip._id.toString())) ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="95" viewBox="0 0 85 95" fill="none">
                                                    <g filter="url(#filter0_d_3031_1559)">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M53.833 69.2545C66.8411 64.6214 76.1072 52.1835 76.1072 37.6073C76.1072 19.0395 61.0676 4 42.4999 4C23.9321 4 8.89258 19.0395 8.89258 37.6073C8.89258 53.1101 19.406 66.1539 33.6615 70.0385L42.4286 82.4387C42.9275 83.1871 44.068 83.1871 44.5669 82.4387L53.833 69.2545Z" fill="#49526A"/>
                                                    </g>
                                                    <defs>
                                                        <filter id="filter0_d_3031_1559" x="0.892578" y="0" width="83.2148" height="95" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                        <feOffset dy="4"/>
                                                        <feGaussianBlur stdDeviation="4"/>
                                                        <feComposite in2="hardAlpha" operator="out"/>
                                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3031_1559"/>
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3031_1559" result="shape"/>
                                                        </filter>
                                                    </defs>
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="95" viewBox="0 0 85 95" fill="none">
                                                    <g filter="url(#filter0_d_2658_4717)">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M53.833 69.2545C66.8411 64.6214 76.1072 52.1835 76.1072 37.6073C76.1072 19.0395 61.0676 4 42.4999 4C23.9321 4 8.89258 19.0395 8.89258 37.6073C8.89258 53.1101 19.406 66.1539 33.6615 70.0385L42.4286 82.4387C42.9275 83.1871 44.068 83.1871 44.5669 82.4387L53.833 69.2545Z" fill="white"/>
                                                    </g>
                                                    <defs>
                                                        <filter id="filter0_d_2658_4717" x="0.892578" y="0" width="83.2148" height="95" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                        <feOffset dy="4"/>
                                                        <feGaussianBlur stdDeviation="4"/>
                                                        <feComposite in2="hardAlpha" operator="out"/>
                                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2658_4717"/>
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2658_4717" result="shape"/>
                                                        </filter>
                                                    </defs>
                                                </svg>
                                            )}
                                        </div>
                                        {renderTravelImage(trip.images)}
                                    </div>
                                    <div className="trip-map-marker-icon-shadow">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="14" viewBox="0 0 55 14" fill="none">
                                            <path opacity="0.5" d="M27.5 0C42.4117 0 54.5 3.13398 54.5 6.99998C54.5 10.866 42.4117 14 27.5 14C12.5883 14 0.5 10.866 0.5 6.99998C0.5 3.13398 12.5883 0 27.5 0Z" fill="url(#paint0_radial_2658_4720)"/>
                                            <defs>
                                                <radialGradient id="paint0_radial_2658_4720" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27.5073 7.00883) rotate(1.1263) scale(26.3569 6.22176)">
                                                <stop/>
                                                <stop offset="1" stopOpacity="0"/>
                                                </radialGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </AdvancedMarker>
                    );
                })
            ) : null}
        </>
    );
}